module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "crew_right"
  }, [_c('div', {
    staticClass: "conInner"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "form_wrap white_box",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "box",
    staticStyle: {
      "width": "751px"
    }
  }, [_c('Tabs', {
    attrs: {
      "type": "card",
      "animated": false,
      "value": _vm.tabIndex
    },
    on: {
      "on-click": _vm.toggleTab
    }
  }, [_c('TabPane', {
    attrs: {
      "label": "收货地址管理",
      "name": "list"
    }
  }, [_c('Card', {
    attrs: {
      "padding": 0,
      "bordered": false,
      "dis-hover": false
    }
  }, [_c('Table', {
    attrs: {
      "columns": _vm.column,
      "data": _vm.addList,
      "no-data-text": "您尚未添加收货地址"
    }
  })], 1)], 1), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": _vm.addrTitle,
      "name": "form"
    }
  }, [_c('Form', {
    staticStyle: {
      "background-color": "#fff",
      "padding-bottom": "20px"
    },
    attrs: {
      "model": _vm.addForm,
      "label-width": 120
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "默认收货地址"
    }
  }, [_c('RadioGroup', {
    model: {
      value: (_vm.addForm.defaultAddress),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "defaultAddress", $$v)
      },
      expression: "addForm.defaultAddress"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "0"
    }
  }, [_vm._v("否")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('label', [_vm._v("必须选择一个地址作为默认地址")])], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "姓名"
    }
  }, [_c('Input', {
    staticClass: "form-input",
    model: {
      value: (_vm.addForm.consigneeName),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "consigneeName", $$v)
      },
      expression: "addForm.consigneeName"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "手机"
    }
  }, [_c('Input', {
    staticClass: "form-input",
    model: {
      value: (_vm.addForm.mobile),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "mobile", $$v)
      },
      expression: "addForm.mobile"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "电话"
    }
  }, [_c('Input', {
    staticClass: "form-input",
    model: {
      value: (_vm.addForm.telephone),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "telephone", $$v)
      },
      expression: "addForm.telephone"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "padding-left": "15px"
    }
  }, [_vm._v("其中联系电话和联系手机必须填写一项。电话格式：区号-电话号码")])], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "地区"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "size": "small",
      "placeholder": "请选择省份",
      "transfer": true
    },
    on: {
      "on-change": _vm.getCityList
    },
    model: {
      value: (_vm.addForm.provinceId),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "provinceId", $$v)
      },
      expression: "addForm.provinceId"
    }
  }, _vm._l((_vm.provinceList), function(item) {
    return _c('Option', {
      key: item.regionId,
      attrs: {
        "value": item.regionId
      }
    }, [_vm._v(_vm._s(item.localName) + "\n                  ")])
  }), 1), _vm._v(" "), _c('Select', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "size": "small",
      "transfer": true
    },
    on: {
      "on-change": _vm.getRegionList
    },
    model: {
      value: (_vm.addForm.cityId),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "cityId", $$v)
      },
      expression: "addForm.cityId"
    }
  }, _vm._l((_vm.cityList), function(item) {
    return _c('Option', {
      key: item.regionId,
      attrs: {
        "value": item.regionId
      }
    }, [_vm._v(_vm._s(item.localName) + "\n                  ")])
  }), 1), _vm._v(" "), _c('Select', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "size": "small",
      "transfer": true
    },
    on: {
      "on-change": _vm.getCountryList
    },
    model: {
      value: (_vm.addForm.regionId),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "regionId", $$v)
      },
      expression: "addForm.regionId"
    }
  }, _vm._l((_vm.regionList), function(item) {
    return _c('Option', {
      key: item.regionId,
      attrs: {
        "value": item.regionId
      }
    }, [_vm._v(_vm._s(item.localName) + "\n                  ")])
  }), 1), _vm._v(" "), _c('Select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.countyId),
      callback: function($$v) {
        _vm.countyId = $$v
      },
      expression: "countyId"
    }
  }, _vm._l((_vm.countryList), function(item) {
    return _c('Option', {
      key: item.regionId,
      attrs: {
        "value": item.regionId
      }
    }, [_vm._v(_vm._s(item.localName) + "\n                  ")])
  }), 1)], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "地址"
    }
  }, [_c('Input', {
    staticClass: "form-input",
    model: {
      value: (_vm.addForm.address),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "address", $$v)
      },
      expression: "addForm.address"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "邮编"
    }
  }, [_c('Input', {
    staticClass: "form-input",
    model: {
      value: (_vm.addForm.zipCode),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "zipCode", $$v)
      },
      expression: "addForm.zipCode"
    }
  })], 1), _vm._v(" "), _c('FormItem', [_c('Button', {
    attrs: {
      "disabled": _vm.btnDisable
    },
    on: {
      "click": _vm.saveAddr
    }
  }, [_vm._v("保存并返回")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "rr_bottom"
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "data"
  }, [_c('h2', [_vm._v("我的收货地址")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tip"
  }, [_c('div', {
    staticClass: "top"
  }), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('img', {
    attrs: {
      "src": "//static.kxymall.com/images/gth.jpg"
    }
  }), _vm._v(" "), _c('div', [_c('h2', [_vm._v("温馨提示")]), _vm._v(" "), _c('p', [_vm._v("1、这里将显示您的收货地址信息")]), _vm._v(" "), _c('p', [_vm._v("2、您还可以管理您的收货地址簿、增加新的收货地址等操作。")])])]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c51748ca"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/member-center/right/address.vue
// module id = 1664
// module chunks = 1